/* eslint-disable import/first */
import React from 'react';
import { FormattedMessage } from 'react-intl';
// import { FaRegAddressBook } from '@react-icons/all-files/fa/FaRegAddressBook';
// import { HiOutlineBookmarkAlt } from '@react-icons/all-files/hi/HiOutlineBookmarkAlt';
// eslint:fix FaRegAddressBook and HiOutlineBookmarkAlt is defined but is never used

import { BiHeart } from '@react-icons/all-files/bi/BiHeart';
// import { RiCustomerService2Line } from '@react-icons/all-files/ri/RiCustomerService2Line';
// eslint:fix  RiCustomerService2Line is defined but is never used

import {
  Address,
  Order,
  Support,
  DeleteAccount,
  SavedCards,
  LogoutIcon,
} from '../../components/Icons';

export const navList = {
  profileMenu: [
    {
      id: 'myFavorites',
      name: <FormattedMessage id="profile_myfavorites" defaultMessage="My Favorites" />,
      urlLink: '/my-favorites/999',
      icon: BiHeart,
    },
    {
      id: 'myAddresses',
      name: <FormattedMessage id="profile_myaddresses" defaultMessage="My Addresses" />,
      urlLink: '/addresses',
      icon: Address,
      langId: 'profile_myaddresses',
    },
    {
      id: 'myOrders',
      name: <FormattedMessage id="profile_myorders" defaultMessage="My Orders" />,
      urlLink: '/order-history',
      icon: Order,
    },
    {
      id: 'myCards',
      name: <FormattedMessage id="profile_mysavedcards" defaultMessage="My Saved Cards" />,
      urlLink: '/my-cards',
      icon: SavedCards,
    },
    {
      id: 'callSupport',
      name: <FormattedMessage id="profile_support" defaultMessage="Support" />,
      urlLink: '/',
      icon: Support,
    },
    {
      id: 'deleteAccount',
      name: <FormattedMessage id="delete_account" defaultMessage="Delete Account" />,
      urlLink: '/delete-account',
      icon: DeleteAccount,
    },
    {
      id: 'logOut',
      name: <FormattedMessage id="profile_logout" defaultMessage="logout" />,
      urlLink: '/logout',
      icon: LogoutIcon,
    },
  ],
};
